module.exports = __webpack_public_path__ + "static/media/galvanicskinresponse.2c90ebc9.pdf";